import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, MessageSquareDashedIcon, BotIcon, BrainCircuitIcon, ListTodoIcon, HandIcon } from 'lucide-react';
const problems = [{
  icon: ClockIcon,
  title: 'Hours writing content',
  desc: 'Staring at a blank screen trying to craft the perfect post or email.'
}, {
  icon: MessageSquareDashedIcon,
  title: 'Not knowing what to ask',
  desc: 'Struggling to articulate exactly what you need from ChatGPT.'
}, {
  icon: BotIcon,
  title: 'Generic AI responses',
  desc: 'Getting robotic, boring text that sounds like everyone else.'
}, {
  icon: BrainCircuitIcon,
  title: 'Mental exhaustion',
  desc: 'Decision fatigue from constantly trying to innovate and create.'
}, {
  icon: ListTodoIcon,
  title: 'Too many tasks',
  desc: 'Overwhelmed by the sheer volume of daily professional demands.'
}, {
  icon: HandIcon,
  title: 'Doing everything manually',
  desc: 'Wasting time on repetitive tasks that AI could do in seconds.'
}];
export function ProblemSection() {
  return <section className="py-32 bg-black-charcoal relative border-y border-white/5" data-id="element-251">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-252">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-253">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-gold text-sm font-bold tracking-[0.2em] uppercase mb-6 block" data-id="element-254">
            Does this sound familiar?
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="font-display font-black uppercase text-3xl md:text-5xl lg:text-6xl text-offwhite leading-[1.05] tracking-tight text-balance" data-id="element-255">
            The problem is not AI. <br data-id="element-256" />
            <span className="text-gold" data-id="element-257">
              It's not knowing how to ask correctly.
            </span>
          </motion.h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-258">
          {problems.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-black-light border border-white/5 p-8 rounded-xl hover:border-gold/20 transition-colors group" data-id="element-259">
              <div className="w-12 h-12 rounded-full bg-black flex items-center justify-center border border-white/10 mb-6 group-hover:border-gold/30 transition-colors" data-id="element-260">
                <item.icon className="w-5 h-5 text-gold" data-id="element-261" />
              </div>
              <h3 className="text-lg font-bold text-offwhite mb-3 tracking-tight" data-id="element-262">
                {item.title}
              </h3>
              <p className="text-muted leading-relaxed" data-id="element-263">{item.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}